<template>
  <v-alert type="error">{{ $t('message.error.desc.authErrorDesc') }}
  </v-alert>
</template>

<script>
export default {
  props: {
    errors: {
      type: Array,
      required: true
    }
  },
  data: () => ({}),
  computed: {
    getErrors () {
      if (this.errors.length > 0) window.scrollTo(0, 0)
      return this.errors
    }
  },
  methods: {
  }
}
</script>

<style scoped>
</style>
